import { render, staticRenderFns } from "./BackSupport.vue?vue&type=template&id=452bfb16&scoped=true"
import script from "./BackSupport.vue?vue&type=script&lang=js"
export * from "./BackSupport.vue?vue&type=script&lang=js"
import style0 from "./BackSupport.vue?vue&type=style&index=0&id=452bfb16&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452bfb16",
  null
  
)

export default component.exports